import React, { useCallback, useEffect, useState } from "react";

import { getFundingOpportunity, getMethods, updateFundingOpportunity } from "services";

import { incomplete, useCancelAsyncOnUnmount, useNavigate, useParams } from "utils";

import { AdminHead, AdminSection, Button, Col, ErrorBoundary, Form, MainPage, Row, TextArea, TextEditor, Message as message } from "components";

import { FundingInputs } from "pages/admin/programs/components/FundingInputs";

export const FundingUpdate = () => {
  const { id } = useParams();

  const [fundingOpportunity, setFundingOpportunity] = useState(null);
  const [methods, setMethods] = useState(false);
  const [loading, setLoading] = useState(true);
  const signal = useCancelAsyncOnUnmount()();
  const navigate = useNavigate();

  const handleExplainerChange = (v) => {
    setFundingOpportunity({
      ...fundingOpportunity,
      fundingAmountExplainer: v,
      signal,
    });
  };

  const complete = (v) => {
    setLoading(true);

    updateFundingOpportunity({
      ...v,
      id: id,
      conditions: v.conditions.split("\n"),
      fundingAmountExplainer: fundingOpportunity.fundingAmountExplainer,
      signal,
    })
      .then(() => {
        navigate("/programs/funding");
        message({
          content: "The gremlins accepted your sacrifice and will consume it! Nom nom nom",
          icon: "gremlin",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const loadFunding = useCallback(() => {
    setLoading(true);

    getFundingOpportunity({
      id: id,
      signal,
    })
      .then((res) => {
        setFundingOpportunity(res.fundingOpportunity);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id, signal]);

  const loadMethods = useCallback(() => {
    setLoading(true);

    getMethods({
      signal,
    }).then((res) => {
      setMethods(res);
      loadFunding();
    });
  }, [signal, loadFunding]);

  useEffect(() => {
    loadMethods();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <MainPage loading={loading} pageName={"admin"}>
      <AdminHead
        headline="Update EU funding"
        link="/programs/funding"
        tooltipText="Back to funding"
        description="Update a funding opportunity here. Funding opportunities can apply to multiple methods and regions."
      />
      <Row className="midi-form">
        <Col>
          <Form name="confirm" onFinish={(v) => complete(v)} onFinishFailed={(v) => incomplete(v)}>
            <ErrorBoundary>
              <FundingInputs fundingOpportunity={fundingOpportunity} methods={methods} />
            </ErrorBoundary>

            <AdminSection headline="Funding conditions" />
            <Row>
              <Col>
                <TextArea
                  name="conditions"
                  label="One per line"
                  rules={[{ required: true }]}
                  autoSize={{ minRows: 4 }}
                  initialValue={fundingOpportunity ? fundingOpportunity.conditions.join("\n") || "" : null}
                />
              </Col>
            </Row>

            <AdminSection headline="Funding explanation" />
            <Row>
              <Col>
                <TextEditor onEditorChange={(v) => handleExplainerChange(v)} value={fundingOpportunity ? fundingOpportunity.fundingAmountExplainer : null} />
              </Col>
            </Row>

            <Row>
              <Col>
                <Form.Item>
                  <Button type="primary" htmlType="submit" disabled={loading} loading={loading}>
                    Update
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </MainPage>
  );
};
